import React, { useState } from 'react';
import { Tabs, Tab, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import GeneralQuestions from './GeneralQuestions';
import WageCost from './WageCost';
import Affiliates from './Affiliates';
import EligibleExpenses from './EligibleExpenses';
const GeneralCompanyInformation = _ref => {
  let {
    financialYear,
    generalQuestions,
    setGeneralQuestions,
    wageCosts,
    setWageCosts,
    affiliates,
    setAffiliates,
    elsterId
  } = _ref;
  const [key, setKey] = useState('project_overview');
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Card, {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Tabs, {
    onSelect: k => setKey(k),
    className: "mb-3 ms-3",
    defaultActiveKey: 'general_questions'
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "general_questions",
    title: t('general_questions')
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(GeneralQuestions, {
    generalQuestions: generalQuestions,
    setGeneralQuestions: setGeneralQuestions
  }))), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "affiliates",
    title: t('affiliates')
  }, /*#__PURE__*/React.createElement(Affiliates, {
    affiliates: affiliates,
    setAffiliates: setAffiliates,
    financialYear: financialYear,
    elsterId: elsterId
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "wage_costs",
    title: t('wage_costs')
  }, /*#__PURE__*/React.createElement(WageCost, {
    financialYear: financialYear,
    wageCosts: wageCosts,
    setWageCosts: setWageCosts
  })))));
};
export default GeneralCompanyInformation;